import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import {
  FaChalkboardTeacher,
  FaUserGraduate,
  FaUsers
} from "react-icons/fa";
import { motion } from "framer-motion";

export default function StatistikSekolah() {
  const [target, setTarget] = useState({
    jumlahGuru: 0,
    jumlahPegawai: 0,
    jumlahSiswa: 0,
  });

  const [display, setDisplay] = useState({
    jumlahGuru: 0,
    jumlahPegawai: 0,
    jumlahSiswa: 0,
  });

  const [loading, setLoading] = useState(true);

  // 🔹 Ambil data dari Firestore
  useEffect(() => {
    const fetchStatistik = async () => {
      try {
        const ref = doc(db, "informasi", "statistikSekolah");
        const snap = await getDoc(ref);

        if (snap.exists()) {
          setTarget(snap.data());
        }
      } catch (err) {
        console.error("Gagal ambil statistik:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStatistik();
  }, []);

  // 🔹 Animasi Count Up
  useEffect(() => {
    if (loading) return;

    const duration = 1200;
    const startTime = performance.now();

    const animate = (time) => {
      const progress = Math.min((time - startTime) / duration, 1);

      setDisplay({
        jumlahGuru: Math.floor(progress * target.jumlahGuru),
        jumlahPegawai: Math.floor(progress * target.jumlahPegawai),
        jumlahSiswa: Math.floor(progress * target.jumlahSiswa),
      });

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [loading, target]);

  if (loading) return null;

  return (
    <section className="py-5 bg-light">
      <div className="container">
        <div className="row text-center g-4">

          {/* TENAGA PENDIDIK */}
          <motion.div
            className="col-md-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="p-4 bg-white rounded-4 shadow-sm h-100">
              <FaChalkboardTeacher size={48} className="text-primary mb-3" />
              <h2 className="fw-bold">{display.jumlahGuru}</h2>
              <p className="mb-0 fw-semibold text-muted">
                Tenaga Pendidik
              </p>
            </div>
          </motion.div>

          {/* PEGAWAI */}
          <motion.div
            className="col-md-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <div className="p-4 bg-white rounded-4 shadow-sm h-100">
              <FaUsers size={48} className="text-warning mb-3" />
              <h2 className="fw-bold">{display.jumlahPegawai}</h2>
              <p className="mb-0 fw-semibold text-muted">
                Pegawai
              </p>
            </div>
          </motion.div>

          {/* PESERTA DIDIK */}
          <motion.div
            className="col-md-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="p-4 bg-white rounded-4 shadow-sm h-100">
              <FaUserGraduate size={48} className="text-success mb-3" />
              <h2 className="fw-bold">{display.jumlahSiswa}</h2>
              <p className="mb-0 fw-semibold text-muted">
                Peserta Didik
              </p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
